module.exports = __webpack_public_path__ + "quotezone-ui/img/central-rail-black.fcfa6cdc.gif";